import React, { Component } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { withRouter } from "react-router-dom";

import EntityTable from "../../component/EntityTable";
import { MERCHANDISER_LIST } from "../../config/lang";

import { userName, movement, userState, userDateJoined } from "../../util/formatter";
import { translate } from "../../util/util";

class List extends Component {
  openRow = row => {
    this.props.history.push(`/merchandiser/${row.id}`);
  };

  rowClass = () => "merch-clickable-row";

  render() {
    const lang = this.props.currentUser.language;

    return (
      <div className="container-fluid merch-page">
        <div className="box p-4">
          <EntityTable
            entity="merchandiser"
            openVisitFn={this.openRow}
            rowClassName={this.rowClass}>
            <TableHeaderColumn dataField="id" isKey hidden></TableHeaderColumn>
            <TableHeaderColumn dataFormat={userName}>{translate(MERCHANDISER_LIST, "user_name", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataField="phone_number">{translate(MERCHANDISER_LIST, "phone_number", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={movement} filterValue={movement}>
              {translate(MERCHANDISER_LIST, "movement", lang)}
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={userState}>{translate(MERCHANDISER_LIST, "user_state", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={userDateJoined}>{translate(MERCHANDISER_LIST, "date_join", lang)}</TableHeaderColumn>
          </EntityTable>
        </div>
      </div>
    );
  }
}

export default withRouter(List);
